import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import PatientDetailsPageItem from "./PatientDetailsPageItem";
import PatientDetailsPageFormDrawer from "../PatientDetailsPageFormDrawer/PatientDetailsPageFormDrawer";
import Button from "@/shared/components/Button/Button";
import ModalDialog from "../ModalDialog/ModalDialog";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import { RootState } from "@/store/store";

import "yet-another-react-lightbox/styles.css";
import "./PatientDetailsPagePhotos.scss";
import { deletePhotos } from "@/store/patients/patients";

export default function PatientDetailsPagePhotos() {
    const [open, setOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { handleDelete } = useDeleteEntity();
    const patientPhotos = useSelector(
        (state: RootState) => state.patients.selectedPatient.patientPhotos,
    );
    const patientId = useSelector(
        (state: RootState) => state.patients.patientId,
    );

    const sortedPhotosArray = [...patientPhotos].sort((a, b) => {
        return (
            new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime()
        );
    });

    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }
    const handleDeletePhotos = async () => {
        function handleDeleteAppointment() {
            dispatch(deletePhotos(patientId));
        }
        await handleDelete({
            entity: "patients/photos/folder",
            id: patientId,
            onSuccess: handleDeleteAppointment,
            message: "Фото клієнта видалені успішно!",
            isLocalLoading: true,
        });
        dispatch(setIsVisibleModalDialog(false));
    };

    return (
        <>
            <Button
                text={"Додати фото"}
                variant={"edit-small"}
                type='submit'
                onClick={() => setOpen(true)}
            />
            <ul className='photos_listing_ul'>
                {sortedPhotosArray && sortedPhotosArray.length > 0 ? (
                    sortedPhotosArray.map((photoData, idx) => (
                        <li key={photoData._id}>
                            <PatientDetailsPageItem photoData={photoData} />
                        </li>
                    ))
                ) : (
                    <p className='no_paragraf'>Фотографії відсутні</p>
                )}
            </ul>
            <PatientDetailsPageFormDrawer
                toggleDrawer={toggleDrawer}
                open={open}
            />
            <ModalDialog
                onConfirm={handleDeletePhotos}
                title='Видалити фотограції?'
                message={`Ви впевнені, що хочете видалити фотографії?`}
            />
        </>
    );
}
